import React, { useState } from "react";
import Modal from "react-modal";
import Card from "./Card";
import { applyCoupon } from "../../Utilities";

export default function CouponPopups({
    showCouPopup,
    setShowCouPopup,
    formSchema,
    setCouponDis,
    couponDis,
    setErrMssge,
    setIsError,
    setIsCpnApplied,
    isCpnApplied,
    price,
    setPrice,
    coupon,
    setCoupon,
    userDetails,
    proCoupon,
}) {
    const [coErr, setCoErr] = useState(false);
    const [coErrCode, setCoErrCode] = useState("");

    let customStyles = {
        content: {
            top: "56%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            borderRadius: "8px",
            height:"400px"
        },
        // overlay: {
        //     background: "rgba(0, 0, 0, 0.85)"
        // }
    };

    if (isCpnApplied) {
        customStyles = {
            content: {
                top: "50%",
                left: "50%",
                right: "auto",
                bottom: "auto",
                marginRight: "-50%",
                transform: "translate(-50%, -50%)",
                borderRadius: "8px",
                border: "0px",
                background: "transparent",
            },
            // overlay: {
            //     background: "rgba(0, 0, 0, 0.85)"
            // }
        };
    }

    return (
        <>
            <Modal
                isOpen={showCouPopup}
                onAfterOpen={() => { }}
                onRequestClose={() => setShowCouPopup(false)}
                style={customStyles}
                contentLabel="Addons Modal"
                ariaHideApp={false}
            >
                <div className={isCpnApplied ? "pad" : ""}>
                    {isCpnApplied ? (
                        <div className="ud-cc-suc-cont">
                            <div className="ud-cc-img">
                                <img
                                    src="https://assets.website-files.com/6188d9da33993f47859b5228/6188d9da33993fd25b9b57fc_discount-badge.png"
                                    loading="lazy"
                                    alt=""
                                    className="image-416"
                                />
                            </div>
                            <div className="ud-cc-code-lbl">Code ‘{coupon}’ applied</div>
                            <div className="text-block-1023">
                                ${Number(couponDis).toFixed(2)}
                            </div>
                            <div className="ud-cc-save-lbl">saved on this order</div>
                            <div className="ud-cc-cl" onClick={() => setShowCouPopup(false)}>
                                Close
                            </div>
                        </div>
                    ) : (
                        <div className="ud-cc-cont">
                            <div className="ud-model-btns-cont">
                                <h2 className="ud-model-heading">
                                    <em className="ud-cc-txt">Enter a coupon code</em>
                                </h2>
                            </div>
                            <div
                                className="ud-model-can"
                                onClick={() => setShowCouPopup(false)}
                            >
                                ×
                            </div>
                            <div className="w-form">
                                <form name="wf-form-mtForm">
                                    <div
                                        className={
                                            coErr ? "ud-cc-input-cont er-bord" : "ud-cc-input-cont"
                                        }
                                    >
                                        <div className="ud-cc-col-1 w-row">
                                            <div className="ud-cc-col-2 w-col w-col-9">
                                                <input
                                                    type="text"
                                                    className="ud-cc-inpt w-input"
                                                    maxLength="256"
                                                    name="field-8"
                                                    placeholder="For example: STYLDOD20"
                                                    value={coupon}
                                                    onChange={(e) =>
                                                        setCoupon(e.target.value.toUpperCase())
                                                    }
                                                />
                                            </div>
                                            <div className="ud-cc-col-3 w-col w-col-3">
                                                <div
                                                    className="ud-cc-aply-btn w-button"
                                                    onClick={(e) => {
                                                        applyCoupon(
                                                            formSchema,
                                                            setCouponDis,
                                                            couponDis,
                                                            setErrMssge,
                                                            setIsError,
                                                            setIsCpnApplied,
                                                            isCpnApplied,
                                                            price,
                                                            setPrice,
                                                            coupon,
                                                            setCoupon,
                                                            setCoErr,
                                                            setCoErrCode
                                                        );
                                                    }}
                                                >
                                                    Apply
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {coErr ? (
                                        <div className="ud-cc-invalid-txt">{coErrCode}</div>
                                    ) : (
                                        ""
                                    )}
                                    <div className="ud-cc-avl-lbl">Available coupons</div>
                                    <div className="ud-cc-card-cont">
                                        {proCoupon.length === 0 ? (
                                            <div
                                                style={{
                                                    marginTop: "30px",
                                                    textAlign: "center",
                                                    fontSize: "24px",
                                                }}
                                            >
                                                No coupons available
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        {proCoupon.map((cp, idx) => {
                                            let date = new Date(
                                                parseInt(cp.valid_till * 1000)
                                            ).toLocaleDateString();
                                            return (
                                                <Card
                                                    cp={cp}
                                                    date={date}
                                                    formSchema={formSchema}
                                                    setCouponDis={setCouponDis}
                                                    couponDis={couponDis}
                                                    setErrMssge={setErrMssge}
                                                    setIsError={setIsError}
                                                    setIsCpnApplied={setIsCpnApplied}
                                                    isCpnApplied={isCpnApplied}
                                                    price={price}
                                                    setPrice={setPrice}
                                                    coupon={coupon}
                                                    setCoupon={setCoupon}
                                                    userDetails={userDetails}
                                                    applyCoupon={applyCoupon}
                                                    setCoErr={setCoErr}
                                                    setCoErrCode={setCoErrCode}
                                                    key={idx}
                                                />
                                            );
                                        })}
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}
                </div>
            </Modal>
        </>
    );
}
